import { render, staticRenderFns } from "./DefiPositionPreview.vue?vue&type=template&id=01b7c481&"
import script from "./DefiPositionPreview.vue?vue&type=script&lang=js&"
export * from "./DefiPositionPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports